<template>
<BaseModal :id="'static-inspection'" :title="title" :size="'lg'">
    <template v-slot:breadcrumb>
        <Breadcrumb :breadcrumb="breadcrumb" />
    </template>
    <template v-slot:content>
        <form class="col-12 p-0" @submit.prevent="form_submit_local()">
            <FormDynamic :form_format="form_format" :form_data="form_data" :array_options="array_options" :for_update="false" :loading_records="loading_records" class="fix-class" @loadRecords="loadRecords($event)" @changePage="changePage($event)" @debounceInput="debounceInput($event)" name="InstantFormModal"/>
            <LocalCentralButtons :modal_name="'static-inspection'" :save_view="save_view" @saveView="save_and_view($event)" />
        </form>
    </template>
</BaseModal>
</template>

<script>
import FormResources from './form_resources'
import FormDynamic from '@/components/FormDynamic.vue'
import Breadcrumb from '@/components/BreadcrumbComponent/Breadcrumb'
import BaseModal from '@/components/BaseModal'
import LocalCentralButtons from './LocalCentralButtons'
import eventBus from '@/plugins/eventBus'
import _ from 'lodash'

export default {

    name: 'FormModal',
    props: [
        "title",
        "content_header",
        "rest_api",
        "notifications",
        "notyf",
        "array_options",
        "breadcrumb",
        "save_view",
        "global_api_rooms_pag"
    ],

    components: {
        FormDynamic,
        Breadcrumb,
        BaseModal,
        LocalCentralButtons,
    },

    data() {
        return {
            form_data: FormResources.form_data,
            form_format: FormResources.form_format,
            form_backup: { ...FormResources.form_data },
            save_and_new: true,
            pagination: {},
            page: 0,
            loading_records: false,
            search: ''
        }
    },

    watch: {
        async 'form_data.room_id'(val) {
            if (val) {
                let json_request = {
                    filter: 'instant_inspection',
                    id: val,
                }

                const response = await this.get(`${this.rest_api}/${JSON.stringify(json_request)}`)

                if (response.status) {
                    if (response.data.inspection_templates.length) {
                        this.array_options.inspection_template_id = response.data.inspection_templates
                        this.form_data.inspection_template_id = ''
                        this.notyf.success('Templates available')
                    } else {
                        this.array_options.inspection_template_id = []
                        this.form_data.inspection_template_id = ''
                        this.notyf.error('No templates available')
                    }
                } else {
                    this.error_handling(response)
                }
            }
        },
        async 'search'()
        {
            this.loadRecords(true)
        }
    },

    methods: 
    {
        debounceInput:  _.debounce(function (e)  {
            console.log('debounce')
            this.search = e.value
        },800),

        form_submit_local() 
        {
            if (!this.form_data.room_id) 
            {
                this.notyf.error('Room is required')
                return false;
            }
            if (!this.form_data.inspection_template_id) 
            {
                this.notyf.error('Template is required')
                return false;
            }

            const form_data = {...this.form_data, room_id: [this.form_data.room_id], inspection_type_id: 1}
            this.form_submit('static-inspection', form_data)
        },

        save_and_view(event) {
            this.$emit('saveView', event)
        },

        async setupForm() {
            this.array_options['room_id'] = []
            this.pagination = {}
            this.page = 0
            this.search = ''
            this.loadRecords()
        },

        async loadRecords(reset_list) 
        {
                if(reset_list)
                {
                    this.array_options['room_id'] = []
                    this.pagination = {}
                    this.page = 0
                }

                if (this.array_options['room_id'].length >= this.pagination?.total) {
                    return;
                }

                this.loading_records = true

                this.page = this.page + 1

                const response = await this.post(this.global_api_rooms_pag, { page: this.page, search: this.search })
                if (response.status) {
                    let data = response.data

                    if (data.data.length) {
                        data.data.forEach((item) => {
                            this.array_options['room_id'].push(item)
                        })
                    }

                    this.pagination = data
                } else {
                    this.error_handling(response)
                }

                this.loading_records = false

        },

        changePage(event) {
            if (event.target.scrollTop + event.target.clientHeight >= (event.target.scrollHeight - 1)) {
                if (!this.loading_records) {
                    this.loadRecords()
                }
            }

        }
    },

    mounted() {
        this.form_data.date = this.currentDateToString()
        this.form_backup.date = this.currentDateToString()
        eventBus.$on('saveAndNew', () => {
            this.save_and_new = false
        }) 
    },

}
</script>
